'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultFormatter;
function defaultFormatter(value, unit, suffix) {
  if (value !== 1) {
    unit += 's';
  }
  return value + ' ' + unit + ' ' + suffix;
}


// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/react-timeago/lib/defaultFormatter.js